import * as tslib_1 from "tslib";
import selectTimeRange from "@/components/selectTimeRange.vue";
import loader from "@/components/loader.vue";
import noDataOverlay from "@/components/noDataOverlay.vue";
import dataService from "@/services/data";
import map from "./map.vue";
import chart from "./chart";
import { Getter, Mutation } from "vuex-class";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.lastReq = null;
        this.noDataAvailable = true;
        this.mapData = [];
        this.countryData = {};
    }
    watchtimeRange() {
        this.updateData();
    }
    watchprofileIds() {
        this.updateData();
    }
    watchsoundSource() {
        this.updateData();
    }
    async updateData() {
        this.loading = true;
        this.noDataAvailable = false;
        // track last request
        this.lastReq = {};
        const lastReqLocal = this.lastReq;
        // get data
        let data = null;
        try {
            data = await dataService.getLocation({
                tz: this.tzName,
                source: this.soundSource,
                from_millis: this.timeRange.min,
                to_millis: this.timeRange.max
            });
        }
        catch (err) {
            this.setLastErr("Could not load Data: " + err);
            return;
        }
        // only let latest request pass
        if (this.lastReq !== lastReqLocal)
            return;
        data = data.Items.filter((v) => this.profileIds.find((p) => v.profile_id == p));
        if (data.length > 0) {
            this.mapData = data;
            // calculate country data
            this.countryData = data.reduce((p, v) => {
                p[v.country] = (p[v.country] || 0) + v.count || 1;
                return p;
            }, {});
            this.noDataAvailable = false;
        }
        else {
            this.mapData = {};
            this.noDataAvailable = true;
        }
        this.loading = false;
    }
    mounted() {
        this.updateData();
    }
};
tslib_1.__decorate([
    Prop()
], widget.prototype, "isFull", void 0);
tslib_1.__decorate([
    Getter("tzName")
], widget.prototype, "tzName", void 0);
tslib_1.__decorate([
    Getter("config/selectedSoundSource")
], widget.prototype, "soundSource", void 0);
tslib_1.__decorate([
    Getter("config/mapTimeRange")
], widget.prototype, "timeRange", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], widget.prototype, "profileIds", void 0);
tslib_1.__decorate([
    Mutation
], widget.prototype, "setLastErr", void 0);
tslib_1.__decorate([
    Watch("timeRange", { deep: true })
], widget.prototype, "watchtimeRange", null);
tslib_1.__decorate([
    Watch("profileIds", { deep: true })
], widget.prototype, "watchprofileIds", null);
tslib_1.__decorate([
    Watch("soundSource", { deep: true })
], widget.prototype, "watchsoundSource", null);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            "select-time-range": selectTimeRange,
            "no-data": noDataOverlay,
            "world-map": map,
            chart: chart
        }
    })
], widget);
export default widget;
